import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProdPageRoutingModule } from './prod-routing.module';

import { ProdPage } from './prod.page';
import { ProdSidePageModule } from '../prod/prodside/prodside.module';
import { ProdMainPageModule } from '../prod/prodmain/prodmain.module';
import { KeyboardPageModule } from '../keyboard/keyboard.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProdPageRoutingModule,
    ProdSidePageModule,
    ProdMainPageModule,
    KeyboardPageModule
  ],
  declarations: [ProdPage]
})
export class ProdPageModule {}
